import React, { useState } from 'react';

const Eligibility = ({ onNext, answers, stepKey }) => {
  const [showSorryModal, setShowSorryModal] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState(answers && answers[stepKey] ? answers[stepKey] : null);

  const handleClick = (e) => {
    const value = e.target.value;
    setSelectedAnswer(value);
    
    if (value == '454') {
      setShowSorryModal(true);
    } else {
      onNext(value);
    }
  };

  const handleCloseModal = () => {
    setShowSorryModal(false);
  };

  const hasAnswered = answers && answers[stepKey];

  return (
    <>
      <div className="qs-card__head"><h2 className="qs-card__title">Eligibility</h2></div>
      {!hasAnswered && (
        <div className="qs-card__body">
          <p className="qs-card__sub">Have you, or any company acting on your behalf, ever previously submitted a complaint to the car loan provider?</p>
          <p className="qs-card__note">
            Note: Complaints relating solely to secret commission do not count for this purpose.
          </p>
          <div className="qs-actions">
            <button 
              type="button" 
              value={454}
              className={`qs-btn qs-btn--no ${selectedAnswer == 454 ? 'btn-active' : ''}`}
              data-ans-id={454}
              onClick={handleClick}>
                Yes</button>

             <button 
                value={455}
               type="button" 
               className={`qs-btn qs-btn--yes ${selectedAnswer == 455 ? 'btn-active' : ''}`}
               data-ans-id={455}
               onClick={handleClick}>
                 No
             </button>
          </div>
        </div>
      )}

      {showSorryModal && (
        <div className="qs-modal is-open" id="sorryModal" aria-hidden="false">
          <div className="qs-modal__backdrop" onClick={handleCloseModal}></div>
          <div className="qs-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="sorryTitle">
            <button className="qs-modal__close" onClick={handleCloseModal} aria-label="Close">
              <i className="bi bi-x-lg"></i>
            </button>
            <div className="qs-modal__body">
              <div className="qs-emoji">🥺</div>
              <h3 id="sorryTitle" className="qs-modal__title">
                <span className="qs-text-danger">Unfortunately,</span> We’re unable to assist further if a complaint has already been submitted to this lender
              </h3>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Eligibility;
